module.exports = __webpack_public_path__ + "2e644bbeff3463fc8eff0cbd10fe79c4.png";